<script setup>
import MessagesAdjusterComponent from "@/Components/Messaging/MessagesAdjusterComponent.vue";
import ReviewQueueComponent from "@/Components/ReviewQueue/ReviewQueueComponent.vue";
import TaskspendingReviewerDash from "@/Components/TasksPending/TaskspendingReviewerDash.vue";
import TasksPendingDashComponent from "@/Components/TasksPending/TasksPendingDashComponent.vue";
import {Permissions} from "@/Utils/Permissions";
</script>

<template>
  <v-row>
    <v-col cols="8" v-if="Permissions.checkPermissions(['messages.list'])">
      <MessagesAdjusterComponent/>
    </v-col>
    <v-col cols="4" v-if="Permissions.checkPermissions(['review-queue.get'])">
      <ReviewQueueComponent/>
    </v-col>
  </v-row>
  <v-row v-if="Permissions.checkPermissions(['tasks-pending.list-reviewer'])">
    <v-col cols="12">
      <TaskspendingReviewerDash/>
    </v-col>
  </v-row>
  <v-row v-if="Permissions.checkPermissions(['tasks-pending.list'])">
    <v-col cols="12">
      <TasksPendingDashComponent/>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>